<!--
 * @Auther: liuguangsheng1
 * @Date: 2021-08-04 18:27:58
 * @LastEditTime: 2021-09-15 18:20:53
 * @Description: 
-->

<template>
    <div class="jdmall-portal">
        <portalHeader :userName="userName"></portalHeader>
        <side></side>
        <portalContent></portalContent>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import portalHeader from '../components/header'
import side from '../components/side'
import portalContent from '../components/content'

export default {
    name: 'index',
    components: {
        portalHeader,
        side,
        portalContent,
    },
    data() {
        return {
            userName: '',
        }
    },
    computed: {
        ...mapGetters({
            menuData: 'menuData',
            microApps: 'microData',
            // ...
        }),
    },
    created() {},
    mounted() {
        // console.log(this.menuData)
        // console.log(this.microApps)
    },
    methods: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.jdmall-portal {
    min-width: 1280px;
    display: flex;
    height: 100%;
    background: #f2f4f6;
}
</style>
